<script>  
    import RadioGroup from '@itslearning/prometheus/assets/inputs/RadioGroup/v1/RadioGroup.svelte';
    import {questionAnswers} from '../../stores';
    import {txt} from '../../i18n/i18n';
  
    export let question = { };
    export let questionAnswer = null;
    export let readonly = false;

    /**
     * set true if you do not want answer to be displayed, useful when e.g. printing survey
     * @type {boolean}
     */
    export let hideAnswer = false;

    const alternatives = [
        {id: 'yes' + question.questionId, label: txt('Yes'), value: 'yes', disabled: readonly }, 
        {id: 'no' + question.questionId, label: txt('No'), value: 'no', disabled: readonly }
    ];

    function handleSelected(e) {
      if (hideAnswer) {
          return;
      }
      answer.answer = e.detail.value;
    }
  
    $: answer = questionAnswer ? questionAnswer : $questionAnswers.find(a => a.questionId === question.questionId);
    $: selectedValue = !hideAnswer && answer && answer.answer ? answer.answer : null;
</script>
  
<RadioGroup 
        id={'Q' + question.questionId} 
        label={txt('Alternatives')} 
        name={'Q' + question.questionId}
        useSmallRadioButtons={true}
        selected={selectedValue}
        on:selected={handleSelected}
        options={alternatives} 
        vertical={true}>
</RadioGroup>
